.attachmentList {
  margin-top: var(--ant-margin-xs);
}

/* Container background keeps chips legible on both the neutral and the primary-coloured owner bubble */
.attachmentChip {
  max-width: 100%;
  margin-inline-end: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: var(--ant-color-text);
  background-color: var(--ant-color-bg-container);
}

.attachmentChip:hover {
  border-color: var(--ant-color-primary);
}

.attachmentChip:focus-visible {
  outline: var(--ant-line-width-focus) solid var(--ant-color-primary-border);
  outline-offset: 1px;
}
